import React from 'react';

import type { IconButtonProps } from '@atlaskit/button/icon/button';
import { UnitTile } from '@atlassian/unit-tile';

export type UnitProfile = {
	unitIconUrl: string | null;
	unitName: string;
};

/**
 * Creates a custom `icon` for the `AppSwitcher` trigger button
 * (`@atlaskit/navigation-system/top-nav-items`, gated behind
 * `platform_dst_ads_appswitcher_improvements`) that renders a `UnitTile`
 * instead of the default app switcher glyph.
 *
 * Intended to be swapped in by a consuming product's app switcher trigger
 * when a unit profile (organizational unit name + icon) is available for the
 * current site, e.g. behind an experiment gate.
 *
 * @see NAVX-5411 - Tracking issue for unit icon on the app switcher trigger
 */
export function createUnitTileAppSwitcherIcon(
	unitProfile: UnitProfile,
): NonNullable<IconButtonProps['icon']> {
	return function UnitTileAppSwitcherIcon({ testId }) {
		return (
			<UnitTile
				unitName={unitProfile.unitName}
				iconUrl={unitProfile.unitIconUrl ?? undefined}
				size="small"
				testId={testId}
			/>
		);
	};
}
